"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHighContrastModeStyles = void 0;
// https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors#browser_compatibility
const FORCED_COLORS_MEDIA_QUERY = '@media screen and (forced-colors: active)';

/**
 * Apply styles for windows high contrast mode(a.k.a WHCM).
 * @param styles css styles
 * @returns WHCM mode styles
 */
const getHighContrastModeStyles = function () {
  let styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    ["".concat(FORCED_COLORS_MEDIA_QUERY)]: styles
  };
};
exports.getHighContrastModeStyles = getHighContrastModeStyles;